import axios from 'axios'
import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'
import crypto from '@/utils/crypto'

export default {
  login: function (aUserName, aPassword) {
    const key = crypto.getRandomInt(1000000000000000, 9999999999999999)
    const iv = crypto.getRandomInt(1000000000000000, 9999999999999999)
    // eslint-disable-next-line promise/param-names
    return new Promise((receive, reject) => {
      axios({
        method: 'post',
        // url: 'http://www.jason235.top:28080/api/SystemApi/Login',
        // url: 'http://127.0.0.1:8888/api/SystemApi/Login',
        url: 'https://manage.beeftochina.com.cn/api/SystemApi/Login',
        headers: {
          'X-Token': getToken() || '',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'X-Requested-With,Content-Type',
          'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,OPTIONS'
        },
        data: {
          MessageType: 1,
          MessageID: btcguid(),
          Data: {
            UserName: aUserName,
            Password: `${key}${iv}${crypto.aesEncryptText(aPassword, key, iv)}`
          }
        }
      }).then((res) => {
        if (res.data.IsSuccess) {
          receive(res.data)
        } else {
          reject(res.data)
        }
      }).catch((err) => {
        reject(err)
      })
    })
  },

  getInfo: function (token) {
    return request({
      url: '/GetAdminUserInfo',
      method: 'post',
      headers: {
        'Authorization': getToken()
      },
      data: {
        MessageType: 2,
        MessageID: btcguid(),
        Data: {
          Token: token
        }
      }
    })
  },

  updateAdminUserPassword: function (params) {
    return request({
      url: '/UpdateAdminUserPassword',
      method: 'post',
      headers: {
        'Authorization': getToken()
      },
      data: {
        MessageType: 4,
        MessageID: btcguid(),
        Data: {
          Password: params.Password,
          NewPassword: params.NewPassword
        }
      }
    })
  },

  logout: function logout(token) {
    return request({
      url: '/Logout',
      method: 'post',
      headers: {
        'Authorization': getToken()
      },
      data: {
        MessageType: 3,
        MessageID: btcguid(),
        Data: {
          Token: token
        }
      }
    })
  }
}
// export function login(aUserName, aPassword) {
//   const key = crypto.getRandomInt(1000000000000000, 9999999999999999)
//   const iv = crypto.getRandomInt(1000000000000000, 9999999999999999)
//   return request({
//     url: '/Login',
//     method: 'post',
//     data: {
//       MessageType: 1,
//       MessageID: btcguid(),
//       Data: {
//         UserName: aUserName,
//         // Password: aPassword
//         Password: `${key}${iv}${crypto.aesEncryptText(aPassword, key, iv)}`
//       }
//     }
//   })
// }

// export function getInfo(token) {
//   return request({
//     url: '/GetAdminUserInfo',
//     method: 'post',
//     headers: {
//       'Authorization': getToken()
//     },
//     data: {
//       MessageType: 2,
//       MessageID: btcguid(),
//       Data: {
//         Token: token
//       }
//     }
//   })
// }

// export function logout(token) {
//   return request({
//     url: '/Logout',
//     method: 'post',
//     headers: {
//       'Authorization': getToken()
//     },
//     data: {
//       MessageType: 3,
//       MessageID: btcguid(),
//       Data: {
//         Token: token
//       }
//     }
//   })
// }

// export function updateAdminUserPassword(params) {
//   return request({
//     url: '/UpdateAdminUserPassword',
//     method: 'post',
//     headers: {
//       'Authorization': getToken()
//     },
//     data: {
//       MessageType: 4,
//       MessageID: btcguid(),
//       Data: {
//         Password: params.Password,
//         NewPassword: params.NewPassword
//       }
//     }
//   })
// }



// WEBPACK FOOTER //
// ./src/api/login.js